import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Table,
  Tag,
} from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";

const columns = [
  {
    title: "Account Name",
    dataIndex: "AccountName",
    key: "AccountName",
    sorter: (a, b) => a.AccountName.length - b.AccountName.length,
    ellipsis: true,
    render: (text) => <span className="onclick-text">{text}</span>,
  },
  {
    title: "Bank",
    dataIndex: "Bank",
    key: "Bank",
    sorter: (a, b) => a.Bank.length - b.Bank.length,
    ellipsis: true,
  },
  {
    title: "Account Number",
    dataIndex: "AccountNumber",
    key: "AccountNumber",
    sorter: (a, b) => a.AccountNumber.length - b.AccountNumber.length,
    ellipsis: true,
  },
  {
    title: "Last Reconciliation",
    dataIndex: "LastReconciliation",
    key: "LastReconciliation",
    sorter: (a, b) => a.LastReconciliation.length - b.LastReconciliation.length,
    ellipsis: true,
  },
  {
    title: "Payments Enabled",
    dataIndex: "PaymentsEnabled",
    key: "",
    render: (PaymentsEnabled) => (
      <span>
        <Tag key={PaymentsEnabled} color={"blue"}>
          {PaymentsEnabled.toUpperCase()}
        </Tag>
      </span>
    ),
    sorter: (a, b) => a.PaymentsEnabled.length - b.PaymentsEnabled.length,
    ellipsis: true,
  },
  {
    title: "Auto-Reconciliation",
    dataIndex: "AutoReconciliation",
    key: "AutoReconciliation",
    render: (AutoReconciliation) => (
      <span>
        <Tag key={AutoReconciliation}>{AutoReconciliation.toUpperCase()}</Tag>
      </span>
    ),
    sorter: (a, b) => a.AutoReconciliation.length - b.AutoReconciliation.length,
    ellipsis: true,
  },
];

export const data = [];
for (let i = 1; i < 20; i++) {
  data.push({
    key: i,
    id: i,
    AccountName: `test Account ${i}`,
    Bank: `test Bank ${i}`,
    AccountNumber: `****${i}${i * 10}${i * 2}`,
    LastReconciliation: `1/${i + 1}/2023`,
    PaymentsEnabled: `ENABLED`,
    AutoReconciliation: `NOT ENABLED`,
    bankInformation: {
      bankName: "Liberty National Bank",
      description: "--",
      routingNumber: "103107392",
      accountNumber: "XXXXXXXX",
      usePrintablDepositSlip: "No",
      address: "13300 S Pennsylvania Ave Oklahoma City, OK 73170",
      paymentsEnabled: "Yes",
      verifiedOnlinePayments: "No"
    },
    accountingInformation:{
      currentBankBalance: "283,976.44",
      asOf: "07/31/2021",
      nextDepositNumber: "1540"
    },
    checkInformation: {
      nextCheckNumber: "6846",
      companyName: "Integrity Oklahoma LLC",
      companyAddress: "PO Box 1451 Bethany, OK 73008"
    }
  });
}

const BankAccountsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
        RightBarMethod("New Bank Deposit", "1", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),

      ]),
    
      RightBarMethod(
        " REPORTS",
        "t2",
        <i className="fa-solid fa-chart-column"></i>,
        [
          RightBarMethod("Check Register", "2", "", "", "/"),
          RightBarMethod("Deposit Register", "3", "", "", "/"),
          RightBarMethod("Trust Account Balance", "4", "", "", "/"),
          RightBarMethod("Bank Account Association", "5", "", "", "/"),
        ]
      ),
    
  ];
const BankAccounts = () => {
  const [isShowMoreFilters, setIsShowMoreFilters] = useState(false);

  const navigate = useNavigate();

  const handleChangePaymentsEnabled = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };
  const handleChangeHiddenAccount = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <div>
      <PageHeading heading="Bank Accounts" />
      <Form name="basic" autoComplete="off" layout="vertical">
        <Row gutter={16}>
          <Col span={5}>
            <Form.Item label="Account Name" name="Account Name">
              <Input />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item label="Bank" name="Bank">
              <Input />
            </Form.Item>
          </Col>
          {isShowMoreFilters && (
            <>
              <Col span={5}>
                <Form.Item label="Account Number" name="Account Number">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={9}>
                <Form.Item
                  label="Last reconciliation"
                  name="Last reconciliation"
                >
                  <Row justify="space-between" gutter={16}>
                    <Col span={11}>
                      <DatePicker
                        format="MM-DD-YYYY"
                        style={{ width: "100%" }}
                      />
                    </Col>

                    <Col span={2}>
                      <p>to</p>
                    </Col>
                    <Col span={11}>
                      <DatePicker
                        format="MM-DD-YYYY"
                        style={{ width: "100%" }}
                      />
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label=" " name="Payments Enabled">
                  <Checkbox onChange={handleChangePaymentsEnabled}>
                    Payments Enabled
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item label=" " name="Payments Enabled">
                  <Checkbox onChange={handleChangeHiddenAccount}>
                    Show Hidden Bank Accounts
                  </Checkbox>
                </Form.Item>
              </Col>
            </>
          )}
          <Form.Item label=" ">
            <Button onClick={() => setIsShowMoreFilters(!isShowMoreFilters)}>
              {isShowMoreFilters ? "Less Filters" : "More Filters..."}
            </Button>
          </Form.Item>
        </Row>
      </Form>

      <Table columns={columns} dataSource={[]} onRow={(record) => {
            return {
              onClick: () =>
                navigate(
                  `/accounting/bank_accounts/bank-account-details/${record.id}`
                ),
            };
          }} />

      <div className="RightSidebar">
        <RightBar RightBarData={BankAccountsRightBar} />
      </div>
    </div>
  );
};

export default BankAccounts;
